'use client'

import { useEffect } from 'react'
import { Button } from '@/components/ui/button'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // 可以在这里添加错误日志上报
    console.error('应用发生错误:', error)
  }, [error])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <div className="w-full max-w-md rounded-lg border border-red-200 bg-red-50 p-6 shadow-md">
        <h1 className="mb-4 text-center text-2xl font-bold text-red-700">出错了</h1>
        <p className="mb-6 text-center text-red-600">
          抱歉，应用程序遇到了问题。
        </p>
        <div className="flex justify-center">
          <Button
            onClick={reset}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            重试
          </Button>
        </div>
      </div>
    </div>
  )
}